import { types } from 'mobx-state-tree';

export type TSideOfSidebar = 'isRightOpen' | 'isLeftOpen';

const sidebarModel = types
  .model('sidebarModel', {
    isRightOpen: types.boolean,
    isLeftOpen: types.boolean,
  })
  .actions(store => ({
    toggle(type: TSideOfSidebar) {
      store[type] = !store[type];
    },
  }));

export const sidebar = types.optional(sidebarModel, {
  isRightOpen: false,
  isLeftOpen: true,
});
